import {DigitalData} from './../../global.d';
export const digitalData: DigitalData = {
  pagename: null,
  url: null,
  env_channel: null,
  section: null,
  enviroment: null,
  sub_section: null,
  step_checkout: null,
  user_Id: null,
  tipo_cliente: null,
  agenzia_se_gia_cliente: null,
  agenzia_permette_ecommerce: null,
  codice_agenzia: null,
  timestamp_visits: null,
  provincia: null,
  cap: null,
  flag_allianz_hp: null,
  data_nascita: null,
  targa: null,
  scadenza: null,
  giorni_scadenza: null,
  tipo_scadenza: null,
  modalita_invio: null,
  tipo: null,
  prezzo_base: null,
  prezzo_totale: null,
  tasse: null,
  sconto: null,
  sconto_convenzione: null,
  modello_versione: null,
  massimale: null,
  proteggi_classe_merito: null,
  tipo_guida: null,
  protezione_rivalsa: null,
  rimorchio: null,
  antifurto: null,
  tipo_pagamento: null,
  convenzione: null,
  metodo_di_pagamento: null,
  tipo_privacy: null,
  numero_polizza: null,
  id_transazione: null,
  id_ordine_finale_salvataggio: null,
  Modulo: [],
  fq_tipo_funnel: null,
  tipo_motore: null,
  valore_veicolo: null,
  custodia_box: null,
  iva_agevolata: null,
  valore_accessori_optional: null,
  pacchetti_optional: null,
};
